import React, { useEffect, useState } from 'react'
import CrmEmpty from "./CrmEmpty";
import { Descriptions, Spin, List, Pagination } from 'antd';
import StringHelper from '../../helpers/StringHelper';
import moment from 'moment-jalaali';
import { useReportsStore } from '../../../store/slices/createReportsSlice';
import { useGeneralStore } from "../../../store/slices/createGeneralSlice";

const faNum = StringHelper.getFarsiNum;

export default function CrmLoginReport({ usrUserID, pageSize, category }) {

    const reports = useReportsStore()
    const general = useGeneralStore();
    const loginDetails = reports.crmLoginReport.data.Items;
    const total = reports.crmLoginReport.data.Total;
    const loading = reports.crmLoginReport.loading;
    const visible = general.view.crmReportModal;
    const [page, setPage] = useState(1);



    const pageChange = (page, pageSize) => {


        setPage(page)
        reports.getCrmLoginReport({
            usrUserID: usrUserID,
            PageSize: pageSize,
            PageNumber: page
        });


    }


    useEffect(() => {
        setPage(1)
        if (usrUserID || category === "Login" || visible) {
            setPage(1)
        }
    }, [usrUserID, category, visible])

    return (
        <div className='crm-login'>
            <Spin spinning={loading}>
                {loginDetails && loginDetails.length > 0 ? (
                    <>

                        <List
                            itemLayout="horizontal"
                            loading={loading}
                            // pagination={{
                            //     onChange: pageChange,
                            //     pageSize: 10,
                            // }}
                            pagination={false}
                            dataSource={loginDetails}
                            renderItem={(login) => {
                                return (
                                    <Descriptions>
                                        {login?.BusinessName && (
                                            <Descriptions.Item label="نام بیزینس">
                                                {login.BusinessName}
                                            </Descriptions.Item>
                                        )}
                                        {login?.LoginDate && (
                                            <Descriptions.Item label="تاریخ ورود">
                                                {faNum(
                                                    moment(login.LoginDate).format(
                                                        " jYYYY/jMM/jDD  ساعت:  HH:mm  "
                                                    )
                                                )}
                                            </Descriptions.Item>
                                        )}
                                        {login?.IPAddress && (
                                            <Descriptions.Item label="آدرس آی پی">
                                                {login.IPAddress}
                                            </Descriptions.Item>
                                        )}
                                    </Descriptions>
                                );
                            }}
                        />
                        <Pagination
                            defaultCurrent={1}
                            current={page}
                            onChange={pageChange}
                            pageSize={pageSize}
                            // PageNumber={page}
                            total={total}
                            showSizeChanger={false} />
                    </>

                ) : <CrmEmpty text="یافت نشد" />}


            </Spin>
        </div>

    )
}